import moment from 'moment'

const holidays = {
  M: {
    // Month, Day
    '01/01': "New Year's Day",
    '07/04': 'Independence Day',
    '11/11': "Veteran's Day",
    '12/24': 'Christmas Eve',
    '12/25': 'Christmas Day',
    '12/31': "New Year's Eve",
  },
  W: {
    // Month, Week of Month, Day of Week
    '1/3/1': 'Martin Luther King Jr. Day',
    '2/3/1': "President's Day",
    '5/5/1': 'Memorial Day',
    '9/1/1': 'Labor Day',
    '10/2/1': 'Columbus Day',
    '11/4/4': 'Thanksgiving Day',
  },
}

export function getHoliday(input: string | moment.Moment | Date): string {
  const date = moment(input)
  // const memorial = (date.get('day') === 1 && (date.get('date') + 7) > 30) ? '5' : null
  const monthDay = date.format('MM/DD')

  if (typeof holidays.M[monthDay] === 'string') {
    return holidays.M[monthDay]
  }

  const diff = 1 + (0 | ((date.get('date') - 1) / 7))
  const monthWeekDay = date.format(`M/${diff}/d`)

  if (typeof holidays.W[monthWeekDay] === 'string') {
    return holidays.W[monthWeekDay]
  }

  // Memorial Day falls on the last Monday of May, so if there is not 5 Mondays, it'll be the 4th Monday
}
